import React from "react";

import { formatNumber, formatNumericCurrency } from "utils";

import { AdminTable, Card, Col, Row } from "components";

export const FarmPointsTab = ({ farm }) =>
  farm && (
    <>
      <Row justify="space-around" align="middle" className="margin-top-200">
        <Col sm={24} md={4}>
          <Card className="content-card stats" style={{ margin: 0, cursor: "default" }}>
            <div className="content center">
              <h3>{formatNumber({ number: parseFloat(farm.pendingPoints) })}</h3>
              <p>Pending points</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={4}>
          <Card className="content-card stats" style={{ cursor: "default" }}>
            <div className="content center">
              <h3>{formatNumber({ number: parseFloat(farm.receivedPoints) })}</h3>
              <p>Received points</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={4}>
          <Card className="content-card stats" style={{ cursor: "default" }}>
            <div className="content center">
              <h3>{formatNumber({ number: parseFloat(farm.pendingFundedPoints) })}</h3>
              <p>Pending funded points</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={4}>
          <Card className="content-card stats" style={{ cursor: "default" }}>
            <div className="content center">
              <h3>{formatNumber({ number: parseFloat(farm.fundedPoints) })}</h3>
              <p>Funded points</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={4}>
          <Card className="content-card stats" style={{ cursor: "default" }}>
            <div className="content center">
              <h3>{formatNumericCurrency(parseFloat(farm.pendingFunds))}</h3>
              <p>Pending funds</p>
            </div>
          </Card>
        </Col>
        <Col sm={24} md={4}>
          <Card className="content-card stats" style={{ cursor: "default" }}>
            <div className="content center">
              <h3>{formatNumericCurrency(parseFloat(farm.funds))}</h3>
              <p>Funds</p>
            </div>
          </Card>
        </Col>
      </Row>
      {farm.vestings && farm.vestings.length > 0 && (
        <Row>
          <Col>
            <AdminTable
              dataSource={farm.vestings}
              config={{
                actions: [],
                exclude: ["vestedPoints", "pendingPoints", "methodId", "fieldSize", "fieldId"],
              }}
            />
          </Col>
        </Row>
      )}
    </>
  );
